import snarkdown from "snarkdown";

/**
 * Very simple markdown to very simple HTML, using a tiny library
 * Used in nested sections for which gatsby isn't doing the MD -> HTML conversion
 *
 * This is not used for actual .md files (e.g. blog entries)
 *
 * @param {string | null | undefined} markdownString
 * @returns {string}
 */
export default function markdownToHTML(markdownString) {
  const html = (markdownString || "")
    .split("\n\n")
    .map((mdChunk) => `<p>${snarkdown(mdChunk)}</p>`)
    .join("");
  return html;
}
